import {
  useActionModalGetContext,
  useActionModalSetContext,
} from "context/ActionModalProvider";
import CommonActionModal from "../CommonActionModal";

const CommonActionModalContainer = ({
  selectedFields = [],
  onActionSaved = () => {},
}) => {
  const { closeActionModal } = useActionModalSetContext();
  const { isOpen } = useActionModalGetContext();

  return (
    isOpen && (
      <CommonActionModal
        isOpen={isOpen}
        selectedFields={selectedFields}
        onActionSaved={onActionSaved}
        onClose={closeActionModal}
      />
    )
  );
};

export default CommonActionModalContainer;
